<div class="page-messages" data-ideals="pageMessagesContainer">
  @for (message of messages(); track message.id) {
    <ideals-alert [alert]="message"/>
  }
</div>
